import { Component } from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NewsRegisterReporterDialogComponent} from '@shared/modules/shared-news/dialogs/news-register-reporter-dialog/news-register-reporter-dialog.component';

@Component({
  selector: 'app-news-register-reporter-name',
  templateUrl: './news-register-reporter-name.component.html',
  styleUrls: [
    '../news-dialogs-styles.scss',
    './news-register-reporter-name.component.scss'
  ]
})
export class NewsRegisterReporterNameComponent {

  public form = new FormGroup({
    firstName: new FormControl('', Validators.compose([Validators.required])),
    lastName: new FormControl('', Validators.compose([Validators.required])),
  });
  public nextButtonDisabled = false;

  public static getDialogSize(): MatDialogConfig {
    return {
      maxWidth: '600px', width: '80vw', maxHeight: '90vh', autoFocus: false
    };
  }

  constructor( public dialogRef: MatDialogRef<NewsRegisterReporterNameComponent>,
               public dialog: MatDialog ) { }

  public onSubmit(): void {
    if (!this.form.valid) {
      return;
    }
    this.nextButtonDisabled = true;
    this.dialogRef.close();
    const config = NewsRegisterReporterDialogComponent.getDialogSize();
    config.data = {
      firstName: this.form.value.firstName,
      lastName: this.form.value.lastName
    };
    this.dialog.open(NewsRegisterReporterDialogComponent, config);
  }
}
